module.exports = __webpack_public_path__ + "img/Ron.37a24558.png";